export const sendToTelegram = async (formData) => {
    const { name, email, phone, requirement } = formData;
    const message = `New contact form submission:\nName: ${name}\nEmail: ${email}\nPhone: ${phone}\nRequirement: ${requirement}`;

    const BOT_TOKEN = '7774132611:AAHQf18aPmHHWGV7MfNtqKzuOKZ1woUu194';
    const CHAT_ID = 7720232613;
    const TELEGRAM_API_URL = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;

    try {
        const response = await fetch(TELEGRAM_API_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                chat_id: CHAT_ID,
                text: message,
                parse_mode: 'HTML'
            }),
        });

        const data = await response.json();

        if (!response.ok) {
            console.error('Telegram API Error:', data);
            throw new Error(`Telegram API Error: ${data.description || 'Unknown error'}`);
        }

        return data;
    } catch (error) {
        console.error('Error sending message to Telegram:', error);
        throw error;
    }
};

// Helper function to get your chat ID
export const getChatId = async () => {
    const BOT_TOKEN = '8064814473:AAEdoAFdHkL-cUCSmjBbBafOBJ7XzUJFNoI';
    const response = await fetch(`https://api.telegram.org/bot${BOT_TOKEN}/getUpdates`);
    const data = await response.json();

    if (data.ok && data.result.length > 0) {
        const chatId = data.result[data.result.length - 1].message.chat.id;
        console.log('Your Chat ID:', chatId);
        return chatId;
    } else {
        console.log('No messages found. Send a message to your bot first.');
        return null;
    }
};

// Test function to verify bot is working
export const testBot = async () => {
    const BOT_TOKEN = '8064814473:AAEdoAFdHkL-cUCSmjBbBafOBJ7XzUJFNoI';
    const response = await fetch(`https://api.telegram.org/bot${BOT_TOKEN}/getMe`);
    const data = await response.json();
    console.log('Bot Info:', data);
    return data;
};